<template>
    <v-list-item
            @click="clicked">
        <v-list-item-avatar>
            <v-icon color="primary">mdi-package</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title :class="item.is_default ? 'font-weight-bold primary--text' : ''">
                {{ item.name }}
            </v-list-item-title>
        </v-list-item-content>

        <!--TODO if even displayed or how is open-->
        <v-list-item-content>
            <v-list-item-title :class="item.is_default ? 'font-weight-bold primary--text' : ''">
                Sortierindex {{ item.order_index }}
            </v-list-item-title>
        </v-list-item-content>

        <v-menu bottom left v-if="item">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                >
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item
                        v-if="!item.is_default"
                        @click.stop="$emit('edit', item)">
                    <v-list-item-title>Paket editieren</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-if="!item.is_default"
                        @click.stop="$emit('delete', item)">
                    <v-list-item-title>Paket löschen</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

    </v-list-item>
</template>
<script>
    export default {
        name: 'package-list-tile',
        props: {
            item: {}
        },
        computed: {},
        methods: {
            clicked() {
                this.$emit('click', this.item)
            }
        }
    }
</script>
